import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import Axios from "axios"
import { toastError } from '../swal/toast'

export const AuthContext = createContext()

const useLogoutClient = () => {
    return async () => {
        localStorage.removeItem("jwt")
    }
}

const useLoginClient = (setClientauth) => {
    const navigate = useNavigate()

    return async (userCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }

        try {
            const result = await Axios.post(
                process.env.REACT_APP_DB_ADDRESS + "/api/login/in",
                { email: userCredentials.email, password: userCredentials.password },
                options
            )

            const token = result.data["token"]

            if (token && token !== "undefined") {
                localStorage.setItem("jwt", token)
                // Decodificamos el token para obtener los datos del usuario
                const decoded = jwtDecode(token)
                const hasAdminRol = decoded.rol === "admin" ? true : false
                const hasStudentRol = decoded.rol === "student" ? true : false
                const hasParentRol = decoded.rol === "parent" ? true : false

                // Actualiza el estado de clientauth en el AuthProvider
                setClientauth(decoded)

                // Redirigir según el rol
                if (hasAdminRol) {
                    if (decoded.mustChangePassword) {
                        return navigate('/admin/change-password')
                    }
                    return navigate('/admin/dashboard')
                } else if (hasStudentRol || hasParentRol) {
                    if (decoded.mustChangePassword) {
                        return navigate(decoded.rol === 'parent' ? '/parent/change-password' : '/student/change-password')
                    }
                    return navigate(decoded.rol === 'parent' ? '/parent/dashboard' : '/student/dashboard')
                } else {
                    if (window.location.pathname !== '/') {
                        return navigate('/')
                    }
                }
            } else {
                // Si el token no es válido, mostrar mensaje de error
                toastError(result.data.message)
            }
        } catch (error) {
            console.error("Error al iniciar sesión:", error)
            toastError('Ocurrió un error al intentar iniciar sesión')
        }
    }
}

export function AuthProvider({ children }) {
    const [clientauth, setClientauth] = useState(null)
    const loginClient = useLoginClient(setClientauth)
    const logoutClient = useLogoutClient()
    const storedToken = localStorage.getItem("jwt")

    useEffect(() => {
        try {
            setClientauth(storedToken ? jwtDecode(storedToken) : null)
        } catch (error) {
            console.error("Error al decodificar el token:", error)
            setClientauth(null)
            localStorage.removeItem("jwt")
        }
    }, [storedToken])

    const contextValue = { clientauth, loginClient, logoutClient, setClientauth }

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context
}